/**
 * Rental agreement type values
 */
export enum RentalAgreementTypeEnum {
	WALK_IN = 'walk_in',
	AGENT = 'agent',
	WEBSITE = 'website',
}
